import {ConfigModel} from '../../shared/services/config/config.model';

export class SetLanguage {
  static readonly type = '[i18n] switch language';
  constructor(public language: string) {}
}

export class SetConfig {
  static readonly type = '[config] set config';
  constructor(public config: ConfigModel) {}
}

export class StartLoading {
  static readonly type = '[loading] start';
}

export class StopLoading {
  static readonly type = '[loading] stop';
}

export class RequestConfirmation {
  static readonly type = '[confirmation] open modal';
  constructor(public i18nKey: string, public variables?: { [key: string]: string }) {}
}
